export default __webpack_public_path__ + "static/media/galpao2.d251d7e9.jpg";